module.exports = __webpack_public_path__ + "static/images/list-2.2e8c1f9.png";